import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PontuacaoDetailComponent } from './pontuacao-detail.component';
import { PontuacaoBeneficioComponent } from './pontuacao-beneficio.component';
import { PontuacaoService } from './pontuacao.service';
import { FormsModule } from '@angular/forms';
import { PontuacaoRoutingModule } from './pontuacao.routes';
import { RespostaListaDinamicaService } from 'unb-questionario-componente';
import { RespostaListaModule } from 'unb-questionario-componente';
import { GrupoFamiliarModule } from '../grupo-familiar/grupo-familiar.module';
/** AngularMaterial **/
import { MatSelectModule, MatButtonModule, MatIconModule, MatInputModule, MatRadioModule, MatProgressBarModule,
   MatSnackBarModule, MatExpansionModule, MatCardModule, MatToolbarModule, MatDialogModule } from '@angular/material';
import { PagerComponent} from '../paginator/pager.component';
import { EstudoCabecalhoModule } from '../estudo-cabecalho/estudo-cabecalho.module';
import { PontuacaoDialogComponent } from './pontuacao-dialog.component';


@NgModule({
    declarations: [
      PontuacaoDetailComponent,
      PontuacaoBeneficioComponent,
      PontuacaoDialogComponent,
    ],
    exports: [
      PontuacaoDetailComponent,
      PontuacaoBeneficioComponent,
      PontuacaoDialogComponent
    ],
    imports: [
      FormsModule, CommonModule,
      MatSelectModule, MatButtonModule,  MatIconModule, MatInputModule, MatProgressBarModule, MatToolbarModule,
      MatSnackBarModule, MatRadioModule, MatExpansionModule, MatCardModule, MatDialogModule,
      PontuacaoRoutingModule, RespostaListaModule, GrupoFamiliarModule, EstudoCabecalhoModule
    ],
    providers: [
      PontuacaoService, PagerComponent, RespostaListaDinamicaService
    ]
})
export class PontuacaoModule {
}
